<template>
  <div>
    <div slot="title">
      <h2 class="label-black">Mis Evaluaciones</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
       <div class="row">
         <div class="col-12 table-responsive" style="margin-top:50px;">
           <table class="table table-striped table-light table-hover table-sm" id="tablaCuestionarios">
             <thead class="thead-custom">
               <tr>
                 <th>ID Cuestionario</th>
                 <th>Nombre del Evaluado</th>
                 <th>Puesto</th>
                 <th>Tipo de Evaluación</th>
                 <th>Estatus de Evaluación</th>
                 <th>Progreso</th>
                 <th>Acciones</th>
               </tr>
             </thead>
             <tbody class='text-dark'>
               <tr v-for='cuestionario in cuestionarios' v-bind:key="cuestionario.idCuestionario">
                 <td>{{ cuestionario.idCuestionario }}</td>
                 <td>{{cuestionario.Evaluado.NombreCompleto}}</td>
                 <td>{{cuestionario.Evaluado.Puesto}}</td>
                 <td>{{cuestionario.TipoEvaluador}}</td>
                 <td>{{cuestionario.EstatusEvaluacion}}</td>
                 <td>{{cuestionario.PreguntasContestadas}} / {{cuestionario.Preguntas}}</td>
                 <td class='d-flex justify-content-around'>
                   <i class='fa fa-plus-square' @click='contestarCuestionario(cuestionario.idCuestionario)' title="Contestar Cuestionario"></i>
                 </td>
               </tr>
               <tr v-if="cuestionarios.length == 0"><td colspan="8">No se encontraron evaluaciones pendientes</td></tr>
             </tbody>
           </table>
         </div>
       </div>
      </div>
    </div>
  </div>
</template>

<script>
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Vue from 'vue'
  import store from '@/store/index'

  export default {
    data() {
      return {
        cuestionarios: []
      }
    },
    components: {
      
    },
    methods: {
      buscarCuestionarios: function () { //Retorna una lista de evaluaciones pendientes en base a ciertos filtros
        //Carga la información necesaria para hacer la petición
        var peticion = {
          "esPrueba": false
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.GetCuestionariosPendientes, peticion,comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.cuestionarios = response.data.Cuestionarios//Carga los datos necesarios
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
          }).catch(e => {
            console.error("encontre un error "+e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
        
      },
      contestarCuestionario: function (idCuestionario) {
        this.$router.push({
          name: 'Cuestionario',
          params: { idCuestionario: idCuestionario}
        })
        }
    },
    mounted: function () {
      this.buscarCuestionarios();
    }

  }

</script>

<style scoped>
  .thead-custom {
    background-color: #004746;
    color: white;
  }
  .custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Evaluaciones/Evaluacion/EstatusEvaluadores.vue